import React from 'react';
import RateManagementWidget from '../RateManagment/RateManagementWidget';
import COLUMNS from './table_columns';
import PropTypes from 'prop-types';

import FileSaver from 'file-saver';
import { toast } from 'react-toastify';

export default class AccessorialRateManagementWidget extends React.Component {

  constructor(props) {
    super(props);
    this.onBulkEditAcceptChanges = this.onBulkEditAcceptChanges.bind(this);
    this.onSingleEditAcceptChanges = this.onSingleEditAcceptChanges.bind(this);
    this.onRevertCurrentRates = this.onRevertCurrentRates.bind(this);
    this.onUpdateBaseWithCurrent = this.onUpdateBaseWithCurrent.bind(this);
    this.onDownload = this.onDownload.bind(this);
    this.onImport = this.onImport.bind(this);
  }

  onRevertCurrentRates() {
    let { dispatchUpdateAccessorial, dispatchGetAccessorials, uiState } = this.props;
    let { terminalObject, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject ? clientObject.value : null;

    dispatchUpdateAccessorial({
      query: {
        operator: "BASE_TO_CURRENT"
      },
      terminalId: terminalId,
      orgId
    }, (err, result) => {
      if (err) {
        toast.error(err.message);
      } else {
        dispatchGetAccessorials();
      }
    });
  }

  onUpdateBaseWithCurrent() {
    let { dispatchUpdateAccessorial, dispatchGetAccessorials, uiState } = this.props;
    let { terminalObject, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject ? clientObject.value : null;

    dispatchUpdateAccessorial({
      query: {
        operator: "CURRENT_TO_BASE"
      },
      terminalId: terminalId,
      orgId
    }, () => {
      dispatchGetAccessorials();
    });
  }

  onBulkEditAcceptChanges() {
    let { dispatchUpdateAccessorial, dispatchGetAccessorials, uiState } = this.props;
    let { selectedObjects, terminalObject, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject ? clientObject.value : null;

    dispatchUpdateAccessorial({
      query: {
        operator: uiState.currentUpdate.operator,
        number: uiState.currentUpdate.number,
        values: selectedObjects
      },
      terminalId,
      orgId
    }, (err, result) => {
      dispatchGetAccessorials();
    });
  }

  onSingleEditAcceptChanges() {
    const { uiState, dispatchGetAccessorials, dispatchUpdateAccessorial } = this.props;
    let { terminalObject, selectedObjects, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject ? clientObject.value : null;


    selectedObjects = selectedObjects.map(obj => {
      let newRate = parseFloat(obj.newRate);
      let rate = parseFloat(obj.rate);      
      if(!isNaN(newRate)){
        obj.newRate = newRate;
      }else{
        obj.newRate = rate;
      }
      return obj;
    });

    dispatchUpdateAccessorial({
      query: {
        operator: uiState.currentUpdate.operator,
        values: selectedObjects
      },
      terminalId,
      orgId
    }, () => {
      dispatchGetAccessorials();
    });
  }

  onDownload() {
    const { uiState, dispatchGetAccessorials, dispatchGetAccessorialsTXT } = this.props;
    let { terminalObject, selectedObjects, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject ? clientObject.value : null;

    dispatchGetAccessorialsTXT({
      terminalId,
      orgId,
      //format: "simple"
    }, (err, data) => {

      if (!err && data && data.length === 1 ) {
        var file = new File([
          JSON.stringify(data[0], null, '\t')
        ], "accessorials.json", { type: "text/plain;charset=utf-8" });
        FileSaver.saveAs(file);
      } else {
        toast.error(err.message);
      }
    });
  }

  onImport(data) {

    if (data && data.file && data.file) {
      const { uiState, dispatchGetAccessorials, dispatchImportJSON } = this.props;
      let { terminalObject, selectedObjects, clientObject } = uiState;
      let terminalId = terminalObject ? terminalObject.value : null;
      let orgId = clientObject ? clientObject.value : null;

      dispatchImportJSON({
        terminalId,
        orgId,
        file: data.file
      }, (err, result) => {
        if (err) {
          toast.error(err.message);
        } else {
          toast.success("Successfully Uploaded Accesorials");
          dispatchGetAccessorials();
        }
      });
    } else {
      toast.error("Invalid File");
    }

    //console.log(data);
  }

  render() {
    let { uiState, setUiState } = this.props;
    return (
      <RateManagementWidget
        addRemove={false}
        setUiState={setUiState}
        downloadType="JSON"
        importAccept={[".json"]}
        terminalName={uiState.terminalObject ? uiState.terminalObject.label : ""}
        onUpdateBaseWithCurrent={this.onUpdateBaseWithCurrent}
        onRevertCurrentRates={this.onRevertCurrentRates}
        selectedObjects={uiState.selectedObjects}
        editColumns={COLUMNS.accessorialEditDataColumns}
        previewColumns={COLUMNS.accessorialPreviewDataColumns}
        onBulkEditAcceptChanges={this.onBulkEditAcceptChanges}
        onSingleEditAcceptChanges={this.onSingleEditAcceptChanges}
        onDownload={this.onDownload}
        onImport={this.onImport}
      />
    );
  }
}


AccessorialRateManagementWidget.propTypes = {
  uiState: PropTypes.object,
  setUiState: PropTypes.func,
  dispatchUpdateAccessorial: PropTypes.func,
  dispatchGetAccessorials: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/components/AccessorialsAndFees/AccessorialRateManagementWidget.js